import { useContext, useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Page } from '~/components/page';
import * as funnels from '~/funnels';
import { SponsoredSolar } from '~/funnels/sponsored-solar';
import { QueryParamsContext } from '~/providers/query-params';
import { SponsoredSolarRouterProvider } from '~/providers/routing';
import { DeletedAccount, ExpiredSession, ExpiredLoginLink, Unexpected } from '~/screens/errors';
import { DEFAULT_FUNNEL_PATH, INTERNAL_ROUTES } from '~/utils/constants';
import { appRedirectPath } from '~/utils/redirects';
import { fetchAndStoreUserIP } from '~/utils/tracking';

export const App = () => {
  const queryParams = useContext(QueryParamsContext);
  const redirect = appRedirectPath({
    defaultFunnel: DEFAULT_FUNNEL_PATH,
    queryParamsRedirect: queryParams.redirectPath,
  });

  useEffect(() => {
    const getUserIp = async () => {
      await fetchAndStoreUserIP();
    };
    getUserIp();
  }, []);

  return (
    <Page>
      <Routes>
        <Route path={INTERNAL_ROUTES.DELETED_ACCOUNT} element={<DeletedAccount />} />
        <Route path={INTERNAL_ROUTES.EXPIRED_LOGIN_LINK} element={<ExpiredLoginLink />} />
        <Route path={INTERNAL_ROUTES.EXPIRED_SESSION} element={<ExpiredSession />} />
        <Route path={INTERNAL_ROUTES.UNEXPECTED} element={<Unexpected />} />
        {/* The trailing * is the wildcard that let us route within this route. do not remove. */}
        <Route
          path={`${INTERNAL_ROUTES.SPONSORED_SOLAR}/*`}
          element={
            <SponsoredSolarRouterProvider>
              <SponsoredSolar />
            </SponsoredSolarRouterProvider>
          }
        />{' '}
        {Object.values(funnels)
          .filter(({ show }) => show())
          .map(({ id, path, Funnel }) => (
            <Route key={id} path={path} element={<Funnel />} />
          ))}
        <Route path="*" element={<Navigate to={redirect} replace />} />
      </Routes>
    </Page>
  );
};
